
  GZ.rentCar.init();
  GZ.defaults.init();

})(this);
